import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// MUI
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// MUI Icons
import PersonIcon from '@mui/icons-material/Person';
import WatchLaterIcon from '@mui/icons-material/WatchLater';

// Custom
import { formats } from '@/lib/formats';

// Types
import { DCRecord } from '@/@types/lib/dataController';

type DialogInfoMetaProps = {
  record: DCRecord
}

const DialogInfoMeta: FC<DialogInfoMetaProps> = (props) => {

  const { t } = useTranslation();

  const { record } = props;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { created_by, created_on } = record;

  const createdByHasName = typeof created_by === 'string' && Number.isNaN(created_by)

  const hasSomeInfo = createdByHasName || created_on;

  return hasSomeInfo ?
    <Box sx={{ pl: 1 }} display="flex" flexDirection="column">
      {created_by && (
        <Box display="flex" alignItems="center" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
          <Tooltip title={`${t('common.created_by')}:`} arrow>
            <PersonIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
          </Tooltip>
          {String(created_by)}
        </Box>
      )}
      {created_on && (
        <Box display="flex" alignItems="center" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
          <Tooltip title={`${t('common.created_on')}:`} arrow>
            <WatchLaterIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
          </Tooltip>
          {moment
            .utc(created_on as moment.Moment | string)
            .local()
            .format(formats.datetime)}
        </Box>
      )}
    </Box>
    : null
}

export default DialogInfoMeta;